module.exports = __webpack_public_path__ + "img/critical_hut.168985df.svg";